import { Component } from '@angular/core';
import { ShellComponent } from './layout/shell.component';
import { AppVersionService } from './core/version/app-version.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [ShellComponent],
  template: '<app-shell />',
  styles: [':host { display: block; width: 100%; min-height: calc(100vh - var(--app-header-height, 50px)); }'],
})
export class AppComponent {
  constructor(appVersion: AppVersionService) {
    document.documentElement.classList.add('spa-ready');
    appVersion.start();
  }
}
